import { render, staticRenderFns } from "./PxCamposCompraProdutosViewM8.vue?vue&type=template&id=165f4fa2&"
import script from "./PxCamposCompraProdutosViewM8.vue?vue&type=script&lang=js&"
export * from "./PxCamposCompraProdutosViewM8.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports